import React from 'react';

const BundledDashboard = () => {
  return (
    <div>
      <h1>Welcome to Your Bundled Dashboard</h1>
      <p>You have access to multiple services:</p>
      <ul>
        <li><a href="/dev-venting-room-dashboard">Venting Room</a></li>
        <li><a href="https://edgene.vercel.app/" target="_blank" rel="noopener noreferrer">STEM Subjects</a></li>
        <li><a href="/entrepreneurship-education-dashboard">Entrepreneurship</a></li>
      </ul>
    </div>
  );
};

export default BundledDashboard;
